import React, {Component} from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Alert from '@mui/lab/Alert'
import ExcelJS from 'exceljs'
import FileSaver from 'file-saver'


import RetirosTable from './RetirosTable'
import LineChartSvg, { formatCompact } from '../depositos/LineChartSvg'
import { AlertTitle, Collapse, Grid, Paper, Snackbar } from '@mui/material'

const {DateTime} = require('luxon')
const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class RetirosPage extends Component {

  constructor() {
    super()
    var fechaFinTemp = DateTime.local().set({hour: 23, minute: 59, second: 59})

    this.state = {
      paises: [],
      entidades: [],
      cajeros: [],
      grupos: [],

      
      retiros: [],
      registros:[],
      detallesPorFecha :[],

      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: '',
      filtroFechaInicio: null,
      filtroFechaFin: fechaFinTemp
    };

    this.btnBucarClick = this.btnBucarClick.bind(this)

    this.cmbGrupos = React.createRef()
    this.cmbPaises = React.createRef()
    this.cmbCajeros = React.createRef()
    this.cmbEntidades = React.createRef()

    this.exportExcel = this.exportExcel.bind(this)

    this.filtroFechaInicio = ""
    this.filtroFechaFin = ""
  }

  fechaFiltroChanged(origen, date) {
    if (date == null) return

    var formatoFechaInicio = "yyyy-LL-dd HH:mm:00"
    var formatoFechaFin = "yyyy-LL-dd HH:mm:59"

    switch (origen) {
      case 'inicio':
        this.setState({
          filtroFechaInicio: date
        })
        this.filtroFechaInicio = date.toFormat(formatoFechaInicio)
        break;
      case 'fin':
        this.setState({
          filtroFechaFin: date
        })
        this.filtroFechaFin = date.toFormat(formatoFechaFin)
        break;
      default:

    }
  }

  btnBucarClick() {
    this.queryRetiros()
    this.queryRegistros()
  }

  handleCloseAlert= (event, reason) => {
    if (reason === 'clickaway') {
      return; // Evitar que se cierre si el usuario hace clic fuera
    }
    this.setState({ mostrarAlerta: false })
  }

  queryEntidades() {
        
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        // alert("Error consultando entidades")
        //console.log('Error respuesta consultando entidades')
        this.setState({
          entidades: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando entidades',
          severidadAlerta: 'error'
        })
      } else {
        this.setState({
          entidades: data
        })
      }
    })
  }

  queryGrupos() {
        
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando grupos")
        //console.log('Error respuesta consultando grupos')
        this.setState({
          grupos: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando grupos',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Grupos consultados')
        this.setState({
          grupos: data
        })
      }
    })
  }

  queryPaises() {
    //console.log('Consultando paises....')

  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/paises/'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando paises")
        //console.log('Error respuesta consultando paises')
        this.setState({
          paises: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando paises',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Paises consultados')
        this.setState({
          paises: data
        })
      }
    })
  }

  queryCajeros() {

    // console.log('Consultando cajeros....')
     var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/cajerosconsultas/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando cajeros")
        //console.log('Error respuesta consultando cajeros')
        this.setState({
          cajeros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error'
        })
      } else {
        //console.log('Cajeros consultados')
        this.setState({
          cajeros: data
        })
      }
    })
    
   }

  queryRetiros() {
    //console.log('Consultando....')

    var filtroIdPais = ''
    var filtroIdGrupo = ''
    var filtroIdCajero = ''
    var filtroIdEntidad = ''

  /*
    if(this.cmbPaises.current.value > 0){
      filtroIdPais = this.cmbPaises.current.value
    }
    */

    if(this.cmbGrupos.current.value !== 0){
      filtroIdGrupo = this.cmbGrupos.current.value
    }

    if(this.cmbCajeros.current.value !== 0){
      filtroIdCajero = this.cmbCajeros.current.value
    }
    
    if(this.cmbEntidades.current.value !== 0){
      filtroIdEntidad = this.cmbEntidades.current.value
    }
    
    if(filtroIdGrupo === '' && filtroIdCajero === '') {
      //alert("Debe seleccionar un grupo o un cajero")
      this.setState({

        mostrarAlerta: true,
        mensajeAlerta: 'Debe seleccionar un grupo o un cajero',
        severidadAlerta: 'warning'
      })
      return
    }

  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
    filtro_id_pais: filtroIdPais,
        filtro_id_grupo: filtroIdGrupo,
        filtro_id_cajero: filtroIdCajero,
        filtro_id_entidad: filtroIdEntidad,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin: this.filtroFechaFin
    },
      url: process.env.REACT_APP_URL_BACKEND + '/retiros/list'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando retiros")
        // console.log('Error respuesta consultando retiros')
        this.setState({
          retiros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando retiros',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Retiros consultados')
        this.setState({
          retiros: data
        })
      }
    })

   }

   queryRegistros() {
    //console.log('Consultando....')

    var filtroIdPais = ''
    var filtroIdGrupo = ''
    var filtroIdCajero = ''
    var filtroIdEntidad = ''

  /*
    if(this.cmbPaises.current.value > 0){
      filtroIdPais = this.cmbPaises.current.value
    }
    */

    if(this.cmbGrupos.current.value !== 0){
      filtroIdGrupo = this.cmbGrupos.current.value
    }

    if(this.cmbCajeros.current.value !== 0){
      filtroIdCajero = this.cmbCajeros.current.value
    }
    
    if(this.cmbEntidades.current.value !== 0){
      filtroIdEntidad = this.cmbEntidades.current.value
    }
    
    if(filtroIdGrupo === '' && filtroIdCajero === '') {
      //alert("Debe seleccionar un grupo o un cajero")
      this.setState({

        mostrarAlerta: true,
        mensajeAlerta: 'Debe seleccionar un grupo o un cajero',
        severidadAlerta: 'warning'
      })
      return
    }

  var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {
    filtro_id_pais: filtroIdPais,
        filtro_id_grupo: filtroIdGrupo,
        filtro_id_cajero: filtroIdCajero,
        filtro_id_entidad: filtroIdEntidad,
        filtro_fecha_inicio: this.filtroFechaInicio,
        filtro_fecha_fin: this.filtroFechaFin
    },
      url: process.env.REACT_APP_URL_BACKEND + '/retiros/registros'
    }

    RestTunel.makePetition(restArgs,(err, data) => {
      if(err) {
        //alert("Error consultando retiros")
        // console.log('Error respuesta consultando retiros')
        this.setState({
          registros: [],
          mensajeError: data.message,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando retiros',
          severidadAlerta: 'error'
        })
      } else {
        // console.log('Retiros consultados')
        this.setState({
          registros: data
        })
      }
    })

   }


   queryDetalles(fechaRecaudo, callback) {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { fecha_recaudo: fechaRecaudo },
      url: process.env.REACT_APP_URL_BACKEND + '/retiros/detalles'
    };
  
    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        console.error('Error consultando detalles:', err);
        callback([]); // Pasar un array vacío en caso de error
      } else {
        this.setState({
          detallesPorFecha: data
        })
        callback(data); // Pasar los datos al callback
      }
    });
  }


    calcularArqueo = (detalle) => {
      const arqueoMap = {
        automatico: new Map(),
        manual: 0 // solo sumamos el total de sobres
      };

      try {
        const contenido = detalle?.detalle ? JSON.parse(detalle.detalle) : {};

        Object.entries(contenido).forEach(([tipo, seccion]) => {
          if (tipo === "automatico" && seccion?.currencies) {
            seccion.currencies.forEach((currency) => {
              currency.bills.forEach((bill) => {
                const denom = bill.denomination;
                const cantidad = bill.amount;

                if (arqueoMap.automatico.has(denom)) {
                  arqueoMap.automatico.set(denom, arqueoMap.automatico.get(denom) + cantidad);
                } else {
                  arqueoMap.automatico.set(denom, cantidad);
                }
              });
            });
          }

          if (tipo === "manual" && seccion?.currencies) {
            seccion.currencies.forEach((currency) => {
              arqueoMap.manual += currency.total_bills || 0;
            });
          }
        });
      } catch (e) {
        console.error("Error parseando el detalle:", e, detalle?.detalle);
      }

      // Convertimos el Map en objeto para acceso directo
      const arqueoAutomatico = {};
      Array.from(arqueoMap.automatico.entries()).forEach(([denominacion, cantidad]) => {
        arqueoAutomatico[`Bill_${denominacion}`] = cantidad;
      });

      return {
        automatico: arqueoAutomatico,
        manual: arqueoMap.manual
      };
    };


    exportExcel() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Recaudos");

      const headers = [
        { header: "Fecha recaudo" },
        { header: "Cajero" },
        { header: "Entidad" },
        { header: "Bill_1000" },
        { header: "Bill_2000" },
        { header: "Bill_5000" },
        { header: "Bill_10000" },
        { header: "Bill_20000" },
        { header: "Bill_50000" },
        { header: "Bill_100000" },
        { header: "Sobres" },
        { header: "Valor total" },
      ];
      sheet.columns = headers;

      const records = this.state.registros;

      records.forEach((item) => {
        const arqueo = this.calcularArqueo(item);

        const getBill = (denom) => arqueo.automatico[`Bill_${denom}`] || 0;

        const row = [
          item.fecha_recaudo,
          item.alias_cajero,
          item.nombre_entidad,
          getBill(1000),
          getBill(2000),
          getBill(5000),
          getBill(10000),
          getBill(20000),
          getBill(50000),
          getBill(100000),
          arqueo.manual, // total de sobres (manual)
          item.valor,
        ];

        sheet.addRow(row);
      });

      const nombreArchivo = "Recaudos.xlsx";
      workbook.xlsx.writeBuffer().then((data) => {
        FileSaver.saveAs(new Blob([data]), nombreArchivo);
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: "Archivo generado",
          severidadAlerta: "success",
        });
      });
    }

  // Series por día de recaudo, separando billetero (Automatico) y sobre.
  computeSeriesPorTipo() {
    const retiros = this.state.retiros || []
    const porDia = {}
    const monedas = new Set()
    retiros.forEach((r) => {
      if (!r.fecha_recaudo) return
      if (r.moneda) monedas.add(r.moneda)
      const iso = String(r.fecha_recaudo).slice(0, 10) // YYYY-MM-DD
      if (!porDia[iso]) porDia[iso] = { billetero: 0, sobre: 0 }
      porDia[iso].billetero += Number(r.valor_billetero) || 0
      porDia[iso].sobre += Number(r.valor_sobre) || 0
    })
    const dias = Object.keys(porDia).sort()
    const labels = dias.map((iso) => {
      const dt = DateTime.fromISO(iso)
      return dt.isValid ? dt.toFormat('dd/LL') : iso
    })
    const billetero = dias.map((iso) => porDia[iso].billetero)
    const sobre = dias.map((iso) => porDia[iso].sobre)
    const moneda = monedas.size === 1 ? Array.from(monedas)[0] : ''
    return { labels, billetero, sobre, moneda }
  }

  componentDidMount() {
    this.queryGrupos()
    this.queryPaises()
    this.queryCajeros()
    this.queryEntidades()
    //this.queryRetiros()
  }

  render() {
    const serie = this.computeSeriesPorTipo()
    const fmtMoneda = (v) => '$' + Number(v).toLocaleString('es-CO', { maximumFractionDigits: 0 }) + (serie.moneda ? ` ${serie.moneda}` : '')
    return (
      <Box>
        <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
          Recaudos
        </Typography>
        
        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                  Buscar recaudos:
              </Typography>

              <Grid container spacing={2} sx={{marginTop: 1}}>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                      <DateTimePicker
                          inputFormat="dd/MM/yyyy HH:mm"
                        label="Fecha/Hora Inicio"
                        value={this.state.filtroFechaInicio}
                        onChange={date => this.fechaFiltroChanged('inicio', date)}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>

                  </Grid>

                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <DateTimePicker
                            inputFormat="dd/MM/yyyy HH:mm"
                          label="Fecha/Hora Fin"
                          value={this.state.filtroFechaFin}
                          onChange={date => this.fechaFiltroChanged('fin', date)}
                          renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>

                  </Grid>

                  <Grid item xs={3}>
                    <FormControl sx={{visibility: 'hidden'}}>
                      <InputLabel>Pais</InputLabel>
                      <Select style={{width: 0}}
                        label="Entidad"
                        inputRef={this.cmbPaises}
                        defaultValue={0}>
                        <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.paises.map(pais => (
                          <MenuItem key={pais.id} value={pais.id}>{pais.nombre}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
          
                  </Grid>
              </Grid>

              <Grid container spacing={2} sx={{marginTop: 1}}>
                  <Grid item xs={3}>
                    <FormControl>
                      <InputLabel>Grupo</InputLabel>
                      <Select style={{width: 200}}
                        label="Entidad"
                        inputRef={this.cmbGrupos}
                        defaultValue={0}>
                        <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.grupos.map(grupo => (
                          <MenuItem key={grupo.id} value={grupo.id}>{grupo.nombre}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item xs={3}>
                    <FormControl>
                      <InputLabel>Cajero</InputLabel>
                      <Select style={{width: 200}}
                        label="Cajero"
                        inputRef={this.cmbCajeros}
                        defaultValue={0}>
                        <MenuItem value={0}>-- Seleccione --</MenuItem>
                        {this.state.cajeros.map(cajero => (
                          <MenuItem key={cajero.id} value={cajero.id}>{cajero.alias}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item xs={3}>
                    <FormControl>
                      <InputLabel>Entidad</InputLabel>
                      <Select style={{width: 200}}
                        label="Entidad"
                        inputRef={this.cmbEntidades}
                        defaultValue={0}>
                        <MenuItem value={0}>-- Todas --</MenuItem>
                        {this.state.entidades.map(entidad => (
                          <MenuItem key={entidad.id} value={entidad.id}>{entidad.nombre}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
          
                  </Grid>
              </Grid>

            </CardContent>
            <CardActions>
              <Button variant="contained" size="large" onClick={this.btnBucarClick}>Buscar</Button>
              <Snackbar
                                open={this.state.mostrarAlerta}
                                onClose={this.handleCloseAlert}
                                autoHideDuration={3000}
                                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                              >
                                <Collapse in={this.state.mostrarAlerta}>
                                    <Alert
                                          severity={this.state.severidadAlerta}
                                          onClose={this.handleCloseAlert}
                                          sx={{ marginTop: 4, width:'100%'}}
                                              >
                                    <AlertTitle>
                                      {this.state.severidadAlerta.toUpperCase()}
                                    </AlertTitle>
                                       {this.state.mensajeAlerta}
                                    </Alert>
                                </Collapse>
              </Snackbar>
            </CardActions>
          </Card>

        </Paper>

        <Divider style={{"marginTop": 10, "marginBotom": 10}} />

        {this.state.retiros.length > 0 &&
          <>
            <Paper elevation={16}>
              <Card>
                <CardContent>
                  <Typography gutterBottom variant="h6" component="div">
                    Tendencia de recaudos por día
                  </Typography>
                  <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                  <Grid container spacing={3} sx={{ mt: 0.5 }}>
                    <Grid item xs={12} md={6}>
                      <LineChartSvg
                        title={`Valor total billetero por día${serie.moneda ? ` (${serie.moneda})` : ''}`}
                        labels={serie.labels}
                        values={serie.billetero}
                        color="#2E7D32"
                        valueFormatter={fmtMoneda}
                        yTickFormatter={formatCompact}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LineChartSvg
                        title={`Valor total sobre por día${serie.moneda ? ` (${serie.moneda})` : ''}`}
                        labels={serie.labels}
                        values={serie.sobre}
                        color="#6A9E2C"
                        valueFormatter={fmtMoneda}
                        yTickFormatter={formatCompact}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Paper>

            <Divider style={{"marginTop": 10, "marginBottom": 10}} />
          </>
        }

        <Paper elevation={16}>
          <Card>
            <CardContent>
              <Typography gutterBottom variant="h6" component="div">
                Listado recaudos:
              </Typography>
              <Divider style={{"marginTop": 10, "marginBottom": 10}} />
              { this.state.retiros.length > 0 &&
                <Button style={{"marginTop": 10, "marginBottom": 10}} variant='contained' onClick={this.exportExcel}>Exportar</Button>
              }
              <Box sx={{display: 'flex', flexWrap: 'wrap'}}>
                <RetirosTable retiros={this.state.retiros} 
                detallesPorFecha = {this.state.detallesPorFecha}
                queryDetalles={this.queryDetalles.bind(this)}/>
              </Box>
            </CardContent>
          </Card>

        </Paper>
      </Box>

    )
  }
}

export default RetirosPage
